<div fxLayout="column">

  <div fxLayout="row" fxFlex>
    <div fxFlex="90" fxLayoutAlign="start center center" style="font-family: 'Century Gothic', sans-serif; font-size: 16px;" >{{title}}</div>
    <div fxFlex="10" fxLayoutAlign="end center center">
      <div (click)="close()" fxLayoutAlign="center center center" fxFlexAlign="center" style="cursor:pointer;">
       <mat-icon>close</mat-icon>
      </div>
    </div>
  </div>


  <div *ngIf="this.mode === 'affirmations'" fxLayout="row" fxFlex style="margin-top:30px;" fxLayoutAlign="start center center">
    <div fxFlex="20"  fxFlexAlign="center center center">
      Παραλήπτες αυτοί που:
    </div>
    <div fxFlex="80" fxFlexAlign="center center center">
      <mat-form-field appearance="outline" style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
        <mat-select [(ngModel)]="selectedCategoryParentCategory" (selectionChange)="parentCategoriesChanged()" placeholder="Επιλέξτε κατηγορία παραληπτών">
          <mat-option *ngFor="let category of parentCategories" [value]="category">{{category.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row" fxFlex [ngStyle]="{'margin-top': mode==='affirmations' ? '0' : '30px;'}" fxLayoutAlign="start center center">
    <div fxFlex="20"  fxFlexAlign="center center center">
      Θέμα:
    </div>
    <div fxFlex="80" fxFlexAlign="center center center">
      <mat-form-field appearance="outline" style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
        <label>
          <input matInput [(ngModel)]="subject" type="text" placeholder="π.χ Αναφορά Συναίνεσης" />
        </label>
      </mat-form-field>
    </div>
  </div>


  <div fxLayout="row"  fxLayoutAlign="start center center">
    <div fxFlex="20" fxFlexAlign="center center center">
      Emails:
    </div>
    <div fxFlex="80" fxFlexAlign="center center center">
      <mat-form-field appearance="outline" style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
        <label>
          <input matInput [(ngModel)]="emails" type="text" placeholder="π.χ john@mail.com;test@mail.com" />
        </label>
      </mat-form-field>
    </div>
  </div>



  <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center center" style="width:100%;">
  <quill-editor fxFlex="100" [styles]="editorStyle" [(ngModel)]="htmlContent"></quill-editor>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center center" style="margin-top:20px;">
    <button [disabled]="formInvalid()" (click)="sendEmail()" color="primary" mat-raised-button>Αποστολή</button>
  </div>


</div>
